export default __webpack_public_path__ + "static/summer_containers101-00d6a1e10d498c15be71e921fdd0d74f.webp";